import { network } from 'services/network';
import { useQuery } from 'react-query';

const getRowDrillDownActivities = (params) => {
    return network.post('api/bo/getRowDrillDownActivities', params).then((response) => {
        return response.data;
    });
};
export const useQueryGetRowDrillDownActivities = (params) => {
    return useQuery(['getRowDrillDownActivities', params], () => getRowDrillDownActivities(params), {
        enabled: Boolean(params.checkId) && Boolean(params.columnAccessor) && Boolean(params.rowAccessor),
    });
};
